import { render, staticRenderFns } from "./websiteDecoration.vue?vue&type=template&id=2d7f6c3b&scoped=true&"
import script from "./websiteDecoration.vue?vue&type=script&lang=js&"
export * from "./websiteDecoration.vue?vue&type=script&lang=js&"
import style0 from "./websiteDecoration.vue?vue&type=style&index=0&id=2d7f6c3b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d7f6c3b",
  null
  
)

export default component.exports